import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./App.css";
import Router from "./Router";
import { ModalProvider } from "./Contexts/ModalContext";
import { UserProvider } from "./Contexts/UserContext";
import { HeaderProvider } from "./Contexts/HeaderContext";

function App() {

  return (
    <div className="App d-flex flex-column min-vh-100 position-relative">
      <UserProvider>
        <HeaderProvider>
          <ModalProvider>
            <Router />
          </ModalProvider>
        </HeaderProvider>
      </UserProvider>
    </div>
  );
}

export default App;
